export const REINDEXING_ERROR = 'REINDEXING_ERROR';
export const REINDEXING_REQUEST = 'REINDEXING_REQUEST';
export const REINDEXING_SUCCESS = 'REINDEXING_SUCCESS';
export const REINDEXING_RESET = 'REINDEXING_RESET';

//FOR cancel digital order
export const CANCEL_DIGITAL_ORDER_ERROR = 'CANCEL_DIGITAL_ORDER_ERROR';
export const CANCEL_DIGITAL_ORDER_REQUEST = 'CANCEL_DIGITAL_ORDER_REQUEST';
export const CANCEL_DIGITAL_ORDER_SUCCESS = 'CANCEL_DIGITAL_ORDER_SUCCESS';
export const CANCEL_DIGITAL_ORDER_RESET = 'CANCEL_DIGITAL_ORDER_RESET';
